import {
  Text,
  Swiper,
  useBreakpoint,
  Breakpoint,
  Box,
} from '@betty/moonlight';

import { AboutUsItemType, aboutUsItems } from './AboutUsSection.constants';
import styles from './AboutUsSection.module.css';
import AboutUsItem  from './components/AboutUsItem';

function AboutUsSection() {
  const breakpoint = useBreakpoint();
  const isDesktop = breakpoint === Breakpoint.DESKTOP;

  return (
    <div className={styles.aboutUsSection}>
      <Text variant="h4" gradient="darkSurfaceAccent">
        About Us
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary">
        We’re changing the game for Ontario’s slot lovers. With handpicked
        games, one-of-a-kind rewards, and promos that actually make sense, Betty
        keeps things fun, fair, and player-friendly.
      </Text>

      <Box
        width="100%"
        flexDirection="column"
        alignItems="center"
        height={{
          desktop: 348,
          tablet: 348,
          mobile: 360,
        }}
        >
        <Swiper<AboutUsItemType>
          items={aboutUsItems}
          renderOverlayItem={(item) => <AboutUsItem item={item} />}
          maxHeight="100%"
          pagination={true}
          width="100%"
          loop={false}
          imageContentFit="cover"
          slidesPerView={isDesktop ? 3 : 1}
          peek={false}
          itemsGap='space-400'
        />
      </Box>
    </div>
  );
}

export default AboutUsSection;
